import apiRoutes from './api.routes';
import ModelService from './model.service';
import api from './api.service';

const TranslationService = new ModelService(apiRoutes.translations, '/translations', 'translations');

TranslationService.NAMESPACE_CORE = 'core';
TranslationService.NAMESPACE_LANDIND = 'landing';
TranslationService.NAMESPACE_SUBSCRIBER_APP = 'subapp';
TranslationService.NAMESPACE_PORTAL = 'portal';
TranslationService.NAMESPACE_CUSTOM_EMAILS = 'customer_emails';

TranslationService.IS_HTML_YES = 1;
TranslationService.IS_HTML_NO = 0;

TranslationService.getNamespaceList = t => ({
  [TranslationService.NAMESPACE_CORE]: t('Core'),
  [TranslationService.NAMESPACE_LANDIND]: t('Landing'),
  [TranslationService.NAMESPACE_SUBSCRIBER_APP]: t('Subscriber app'),
  [TranslationService.NAMESPACE_PORTAL]: t('Portal'),
  [TranslationService.NAMESPACE_CUSTOM_EMAILS]: t('Custom emails'),
});

TranslationService.getNamespaceOptions = t => TranslationService
  .prepareOptionsFromSimpleObject(TranslationService.getNamespaceList(t));

TranslationService.getNamespaceTitle = (status, t) => {
  const label = TranslationService.getNamespaceList(t)[status];
  return label || '-';
};

TranslationService.getExportUrl = (token) => {
  return api.apiUrl + TranslationService.baseUrl + '/export-xls?token=' + token;
};

TranslationService.sendImportFile = async props => api.catchError(async () => {
  const { data } = await api.post(`${TranslationService.baseUrl}/import-xls`, props);
  return data;
});

export default TranslationService;



// WEBPACK FOOTER //
// ./src/services/translation.service.js